import React, { useEffect, useState } from "react";
import "../../../../assets/styles/publicResult.scss";
import {
  getAverageBySongs,
  getResultClassName,
  getTotalBySongs,
  getSortedGroups,
} from "../../../../utils/scoreUtils";
import { GroupData } from "@/types/GroupData";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";

const QS24: React.FC = () => {
  const [groups, setGroups] = useState<GroupData[]>([]);

  useEffect(() => {
    const fetchGroups = async () => {
      const snapshot = await getDocs(collection(db, "groups"));
      const fetchedGroups: GroupData[] = snapshot.docs.map((doc) => ({
        ...(doc.data() as GroupData),
        id: doc.id,
      }));

      const filtered = fetchedGroups.filter((group) => {
        const year = group.createdAt?.toDate?.().getFullYear?.();
        return (
          year === 2025 &&
          group.entryClass === "QuartetContest" &&
          !group.isDeleted
        );
      });

      const sorted = getSortedGroups(filtered, {}, false, [1, 2]);

      setGroups(sorted);
    };

    fetchGroups();
  }, []);

  const restGroups = groups.slice(10);
  const top11 = getSortedGroups(groups, {}, false, [1, 2]).slice(0, 10);
  const drawGroups = [...top11]
    .sort((a, b) => (a.finalOrder ?? Infinity) - (b.finalOrder ?? Infinity))
    .slice(0, 10);
  const mtGroup = getSortedGroups(groups, {}, false, [1, 2])[10];

  return (
    <div className="main">
      <div className="result-area">
        <h1>
          Official Scoring Summary
          <br />
          Japan Barbershop Convention 2025 Quartet Semifinals
          <br />
          Yokohama; August 23, 2025
        </h1>

        <table className="result-table">
          <thead>
            <tr>
              <th className="text-left head-group">Group</th>
              <th className="text-left">Songs</th>
              <th>MUS</th>
              <th>PER</th>
              <th>SNG</th>
              <th>Total</th>
            </tr>
          </thead>
          {restGroups.map((group, index) => (
            <tbody
              key={group.id}
              className={index % 2 === 0 ? "group-even" : "group-odd"}
            >
              <tr className="tr-head">
                <td className="text-left font-bold">
                  <span className="runk-number">{index + 11}</span>
                  {group.groupName}
                </td>
                <td className="text-left font-bold total-point">
                  {getTotalBySongs(group, {}, false, [1, 2])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2], ["Mus"])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2], ["Per"])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2], ["Sng"])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2])}
                </td>
              </tr>
              <tr>
                <td></td>
                <td className="text-left">
                  {group.songName1}
                  <span className="arranged">{group.songArranged1}</span>
                </td>
                <td
                  className={getResultClassName(
                    "Mus",
                    "songPenaltyMus1",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultMus1}
                </td>
                <td
                  className={getResultClassName(
                    "Per",
                    "songPenaltyPer1",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultPer1}
                </td>
                <td
                  className={getResultClassName(
                    "Sng",
                    "songPenaltySng1",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultSng1}
                </td>
                <td>{getAverageBySongs(group, {}, false, [1])}</td>
              </tr>
              <tr className="tr-foot">
                <td></td>
                <td className="text-left">
                  {group.songName2}
                  <span className="arranged">{group.songArranged2}</span>
                </td>
                <td
                  className={getResultClassName(
                    "Mus",
                    "songPenaltyMus2",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultMus2}
                </td>
                <td
                  className={getResultClassName(
                    "Per",
                    "songPenaltyPer2",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultPer2}
                </td>
                <td
                  className={getResultClassName(
                    "Sng",
                    "songPenaltySng2",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultSng2}
                </td>
                <td>{getAverageBySongs(group, {}, false, [2])}</td>
              </tr>
            </tbody>
          ))}
        </table>
        <div className="info">
          <h2>Draw</h2>
          {drawGroups.map((g, i) => (
            <React.Fragment key={g.id}>
              <>
                <span className="info-font-bold">{i + 1}:</span>{" "}
                <span className="draw-span">{g.groupName}</span>
              </>
              {i < drawGroups.length - 1}
            </React.Fragment>
          ))}
          {mtGroup && (
            <>
              <span className="info-font-bold">MT:</span>
              <span className="draw-span">{mtGroup.groupName}</span>
            </>
          )}
          <p>Singing Order in Finals: MT &gt; 1. &gt; 2. &gt; … &gt; 10.</p>
        </div>

        <div className="info">
          <h2>Panel</h2>
          <p>ADM: Steve Scott</p>
          <p>MUS: Mark Hale</p>
          <p>PER: Sean Devine</p>
          <p>SNG: Ryan Wisniewski</p>
        </div>
      </div>
    </div>
  );
};

export default QS24;
